import { IDatasource } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { IScheduledPoll, IScheduledPollPayload } from './../poll_interfaces';

export class ScheduledPollDatastore implements IDatasource {
  id: string;
  store: IScheduledPoll[];

  constructor() {
    this.id = 'scheduled_poll';
    this.store = [];
  }

  write(data: IScheduledPollPayload): this {
    if (data) {
      this.store = data.scheduledpoll;
    }
    return this;
  }

  initialize(): this {
    this.store = [];
    return this;
  }

  read(): IScheduledPoll[] {
    return this.store;
  }

  report(fn: (store: IScheduledPoll[]) => any): any {
    return fn(this.store);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/datastore/scheduled_poll_datastore.ts